/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class WebhooksService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns any No response body
     * @throws ApiError
     */
    public webhooksGocardlessCreate(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/webhooks/gocardless/',
        });
    }

    /**
     * @returns any No response body
     * @throws ApiError
     */
    public webhooksTriggerCreate({
        key,
    }: {
        key: string,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/webhooks/trigger/',
            query: {
                'key': key,
            },
        });
    }

}
